import TemplateView from '../../../TemplateView'
import AddressForm from './AddressForm'
import _ from 'underscore'

export default class AddressFormWithControls extends TemplateView {

    constructor({
        fieldsChangeCallback = () => {},
        toggleAddressFormCallback = () => {},
    }) {
        super()

        this.callbacks = {
            fieldsChangeCallback,
            toggleAddressFormCallback,
        }

        this.state = {
            countries: [],
            statesByCountry: {},
            address: '',
            city: '',
            zip: '',
            country: '',
            state: '',
            isAddressFormOpen: false,
            disabled: false,
        }

        this.onAnyStatePropertyChanged(['address', 'city', 'zip', 'country', 'state', 'countries', 'statesByCountry'], () => {
            this.addressForm.setState({
                address: this.state.address,
                city: this.state.city,
                zip: this.state.zip,
                country: this.state.country,
                state: this.state.state,
                countries: this.state.countries,
                statesByCountry: this.state.statesByCountry,
            })
            this._refreshAddressInfo()
        })

        this.onStatePropertyChanged('disabled', (disabled) => this.$editBillingLink.toggle(!disabled))

        this.onStatePropertyChanged('isAddressFormOpen', () => this._refreshAddressInfo())
    }

    templateHtml() {
        return `<div class="addressFormPanel">
                    <div class="titleBlock">
                        <div class="addressTitle"><%=addressFormTitle%></div>
                        <div class = "buttonsContainer">
                            <a class="dashedLink clearAll"><%=clearAllButton%></a>
                            <div class="addressBillingSeparator"/>
                            <div class="closeAddressEditing"/>
                        </div>
                    </div>
                    <div class="addressData">
                        <div class="preview"></div>
                        <a class="dashedLink editBillingLink"><%=editButton%></a>
                    </div>  
                    <div class="newBillingDataContainer">
                        <a class="dashedLink"><%=enterBillingAddress%></a>
                        <div class="tip"><%=billingAddressTip%></div>
                    </div>
                    <div class="addressFormContainer"/>
                </div>`
    }

    messageKeys() {
        return {
            addressFormTitle: 'licenses.card_details.title.fields.address',
            clearAllButton: 'licenses.address_form.buttons.clear',
            enterBillingAddress: 'licenses.address_form.buttons.enter',
            billingAddressTip: 'licenses.address_form.buttons.enter.tip',
            editButton: 'licenses.address_form.buttons.edit',
        }
    }

    afterRender() {
        this.$buttonsContainer = this.find('.buttonsContainer')
        this.$addressData = this.find('.addressData')
        this.$billingDataContainer = this.find('.newBillingDataContainer')
        this.$editBillingLink = this.find('.editBillingLink')
        this.$preview = this.find('.preview')

        this.$editBillingLink.click(() => this.callbacks.toggleAddressFormCallback(true))

        this.$billingDataContainer.find('.dashedLink').click(() => this.callbacks.toggleAddressFormCallback(true))

        this.find('.closeAddressEditing').click(() => this.callbacks.toggleAddressFormCallback(false))

        this.find('.clearAll').click(() => {
            this.callbacks.fieldsChangeCallback({
                address: '',
                city: '',
                zip: '',
                country: '',
                state: '',
            })
        })

        this.addressForm = new AddressForm({
            fieldsChangeCallback: this.callbacks.fieldsChangeCallback,
            menuPositionParams: {
                my: "left bottom",
                at: "left top",
            },
        }).init(this.find('.addressFormContainer'))
        this._refreshAddressInfo()
    }

    _refreshAddressInfo() {
        const isAddressFormFilled = this._isAddressFormFilled()
        this.addressForm.toggle(this.state.isAddressFormOpen)
        this.$buttonsContainer.toggle(this.state.isAddressFormOpen)
        this.$addressData.toggle(!this.state.isAddressFormOpen && isAddressFormFilled)
        this.$billingDataContainer.toggle(!this.state.isAddressFormOpen && !isAddressFormFilled)

        if (isAddressFormFilled) {
            this.$preview.empty()
            this.$preview.append(this._formatPreview())
        }
    }

    _formatPreview() {
        const result = []
        if (this.state.address) result.push(_.escape(this.state.address))
        if (this.state.city) result.push(_.escape(this.state.city))
        if (this.state.state) result.push(_.escape(this.state.state))
        if (this.state.zip) result.push(_.escape(this.state.zip))
        if (this.state.country) result.push(_.escape(this.state.countries.find((item) => item.code === this.state.country).name))

        return result.join(', ')
    }

    _isAddressFormFilled() {
        const hasStateIfNeeded = !this.state.statesByCountry[this.state.country] || !!this.state.statesByCountry[this.state.country] && this.state.state
        return !!(this.state.address && this.state.city && this.state.zip && this.state.country && hasStateIfNeeded)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/AddressFormWithControls.js